var _defs, _path, _polyline, _line, _line2, _polyline2, _polyline3, _polyline4, _line3, _line4, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse, _rect2, _ellipse2, _rect3, _path15, _path16, _ellipse3, _rect4, _rect5, _line5, _line6, _line7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKurta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-11,.cls-12,.cls-13,.cls-14,.cls-2,.cls-6,.cls-7{fill:#fff;}.cls-1,.cls-10,.cls-13,.cls-14,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#000;}.cls-1,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-1{stroke-width:3px;}.cls-10,.cls-3,.cls-4,.cls-5,.cls-8,.cls-9{fill:none;}.cls-14,.cls-3,.cls-4,.cls-5{stroke-width:0.99px;}.cls-4{stroke-dasharray:1.97 1.97;}.cls-5{stroke-dasharray:1.95 1.95;}.cls-6{stroke-width:0.56px;}.cls-12,.cls-7{stroke-width:0.28px;}.cls-7{stroke-dasharray:0.84;}.cls-10,.cls-8,.cls-9{stroke-width:0.21px;}.cls-9{stroke-dasharray:0.84 0.84;}.cls-10{stroke-dasharray:0.83 0.83;}.cls-11,.cls-12{stroke:#010101;}.cls-11{stroke-width:0.75px;}.cls-12{stroke-dasharray:0.75;}.cls-13{stroke-width:1.09px;}.cls-14{stroke-dasharray:1.97;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.3,194.2a419.7,419.7,0,0,0-2.66,100l12.63,135.65-63.43,2.06-20.12.65-20.13-.65-63.43-2.06,12.63-135.65a420.22,420.22,0,0,0-2.66-100l-3.94-26.83L74.82,290.15,44.69,273.3l69.61-158a40.17,40.17,0,0,1,30-23.41l45.34-7.73,21.05.69,21-.69,45.34,7.73a40.17,40.17,0,0,1,30,23.41l69.6,158-27.9,15.61L288.24,167.37Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "280.52 317.33 290.67 427.24 210.65 429.85 130.62 427.24 140.77 317.33"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 280.52,
    y1: 317.33,
    x2: 280.61,
    y2: 318.32
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.79,
    y1: 320.28,
    x2: 290.49,
    y2: 425.27
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "290.58 426.25 290.67 427.24 289.68 427.27"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "287.73 427.33 210.65 429.85 132.59 427.3"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "131.61 427.27 130.62 427.24 130.71 426.25"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 130.89,
    y1: 424.29,
    x2: 140.59,
    y2: 319.3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 140.68,
    y1: 318.32,
    x2: 140.77,
    y2: 317.33
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 206.52,
    y: 92.82,
    width: 10.68,
    height: 15.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.35,81v.62a16,16,0,0,1-1.91,3.08C232.69,90.82,223.16,95,212.19,95h0a4.51,4.51,0,0,0-1.5.26c-10.34-.36-19.21-4.42-23.76-10.23a16.18,16.18,0,0,1-2-3.23h0a4.48,4.48,0,0,1-.19-.44v-.83c.06.14,0-.15,0,0v-.14h.12c3.26-7.26,12.21-10.87,27-10.87C224.61,69.5,235.72,75.26,239.35,81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M205.93,93.82h0a4.55,4.55,0,0,1,4.55,4.54h0l.33,5.83c-.19,0-4.7-.25-4.89-.28-10.81-1.1-14.53-3.37-19.28-9.47a14.21,14.21,0,0,1-3.23-8.82v-10a7.22,7.22,0,0,0,0,.81h0a13.37,13.37,0,0,0,1.21,4.77h0a16.65,16.65,0,0,0,2,3.23C191.38,90.59,194.68,92.15,205.93,93.82Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.93,103.32l-3.92-.23C195.34,102,191.83,99.75,187.3,94a13.3,13.3,0,0,1-3.05-8.31v-3.3A17.86,17.86,0,0,0,186,85c4.85,6.23,8.39,7.94,19.84,9.64H206a3.71,3.71,0,0,1,3.7,3.7v.05Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M217.8,93.9h0a4.55,4.55,0,0,0-4.55,4.55h0l-.33,5.83c.19,0,4.7-.25,4.89-.28,10.81-1.1,14.53-3.37,19.28-9.46a14.27,14.27,0,0,0,3.23-8.83V75.76a7.13,7.13,0,0,1,0,.8h0a13.39,13.39,0,0,1-1.22,4.78h0a15.73,15.73,0,0,1-2,3.23C232.34,90.67,229,92.24,217.8,93.9Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M214.08,98.47v0a3.71,3.71,0,0,1,3.69-3.71h.14c11.46-1.7,15-3.41,19.84-9.64a16.7,16.7,0,0,0,1.73-2.67v3.3a13.3,13.3,0,0,1-3,8.31c-4.53,5.81-8,8.06-18.72,9.15l-3.91.22Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M240.33,75.43h0a13.56,13.56,0,0,1-1.23,4.8h0l0,.11c-3.62-5.79-14.42-10-27.18-10s-23.56,4.19-27.18,10l-.06-.11h0a13.48,13.48,0,0,1-1.21-4.78h0c.64-7.58,13.13-13.63,28.45-13.63S239.67,67.85,240.33,75.43Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.83,78.59c-4.55-5.49-15.07-9.09-27-9.09s-22.41,3.6-27,9.09a12.49,12.49,0,0,1-.62-3.14c.66-7.06,13-12.79,27.59-12.79s26.93,5.73,27.6,12.79A12.5,12.5,0,0,1,238.83,78.59Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M239,78.19l-.13.4-.28-.32"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M238,77.66c-4.93-5-14.92-8.16-26.13-8.16-11.43,0-21.6,3.32-26.41,8.46"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M185.17,78.27l-.28.32c0-.13-.09-.27-.13-.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M184.55,77.38a13.81,13.81,0,0,1-.28-1.93c.67-7.06,13-12.79,27.6-12.79s26.93,5.73,27.6,12.79a13.29,13.29,0,0,1-.39,2.34"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.17,139.38v-.83l.24-33.26v-.77a39.48,39.48,0,0,0,4,.17h1.68c.78,0,1.88,0,3.21-.17v.91l.25,33.11v.84"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M208,138.55l.24-33.11c1.22.08,2.2.1,2.86.1h1.5c.66,0,1.65,0,2.86-.1l.24,33.11"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.86,
    cy: 109.84,
    rx: 1.88,
    ry: 1.79
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 211.67,
    y: 107.4,
    width: 0.39,
    height: 4.99
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.86,
    cy: 133.31,
    rx: 1.88,
    ry: 1.79
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 211.67,
    y: 130.88,
    width: 0.39,
    height: 4.99
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M207.17,139.44v.83l.24,33.26v.77a39.48,39.48,0,0,1,4-.17h1.68c.78,0,1.88.05,3.21.17v-.9l.25-33.12v-.84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M208,140.27l.24,33.11c1.22-.08,2.2-.1,2.86-.1h1.5c.66,0,1.65,0,2.86.1l.24-33.11"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.06,
    cy: 156.45,
    rx: 1.88,
    ry: 1.79
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 211.86,
    y: 153.9,
    width: 0.39,
    height: 4.99
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 230.78,
    y: 153.9,
    width: 36.52,
    height: 41.89
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 346.5,
    y1: 280.17,
    x2: 371.67,
    y2: 266.83
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 51,
    y1: 264,
    x2: 77,
    y2: 278
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 232.5,
    y1: 158.89,
    x2: 264.5,
    y2: 158.89
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKurta);
export default __webpack_public_path__ + "static/media/kurta.33930a36d7c57e4586e625159d52b548.svg";
export { ForwardRef as ReactComponent };